import React, { ReactNode } from 'react';
import styled, { ThemeProvider, useTheme } from 'styled-components';
import { app2vid } from './app2vid';
import { automotive } from './automotive';
import { covideo } from './covideo';
import { kennected } from './kennected';
import { provideo } from './provideo';
import { branding } from './branding';
import { cdk } from './cdk';

interface IProps {
  children: ReactNode;
  themeName:
    | 'covideo'
    | 'automotive'
    | 'kennected'
    | 'app2vid'
    | 'provideo'
    | 'branding'
    | 'cdk';
  additionalStyles?: Record<string, string>;
}

const theme = {
  covideo,
  automotive,
  kennected,
  app2vid,
  provideo,
  branding,
  cdk,
};

export const CovideoThemeProvider: React.FC<IProps> = ({
  children,
  themeName,
  additionalStyles,
}) => {
  // Merge the selected theme with additional styles
  const appliedTheme = {
    ...theme[themeName], // Base theme
    ...additionalStyles, // Additional styles
  };

  return <ThemeProvider theme={appliedTheme}>{children}</ThemeProvider>;
};

export { useTheme as useCovideoTheme, styled as covideoStyled };
